// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"SupportCategoryList_categoryList__QgDV3"};